import { Formulario } from '../_models';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AlertService } from './alert.service';
import {environment} from '../../environments/environment'

@Injectable({
    providedIn: 'root'
})

export class FormularioService {

    getFormulario(): Observable<any> {
        return this.http.get<Formulario[]>(`${environment.apiUrl}/Formulario/GET`);
    }

    constructor(private http: HttpClient,
        private alertService: AlertService) { }


}
